// INGLÉS
export const notifications = {
  // Traducciones existentes
  p1: `NEW CHECK-IN`,
  p2: `completed check-in successfully`,
  p3: `NEW SERVICE REQUEST`,
  p4: `has requested `,
  p5: ``,
  p6: ``,
  p7: ``,
  p8: ``,

  booking: {
    new: {
      title: 'حجز جديد',
      body: 'تم إنشاء حجز جديد.'
    },
    update: {
      title: 'تم تحديث الحجز',
      body: 'تم تحديث أحد الحجوزات.'
    },
    cancelled: {
      title: 'تم إلغاء الحجز',
      body: 'تم إلغاء أحد الحجوزات.'
    },
    request_created: {
      title: 'طلب حجز جديد',
      body: 'أرسل أحد النزلاء طلب حجز.'
    },
    request_approved: {
      title: 'تمت الموافقة على طلب الحجز',
      body: 'تمت الموافقة على أحد طلبات الحجز.'
    },
    request_rejected: {
      title: 'تم رفض طلب الحجز',
      body: 'تم رفض أحد طلبات الحجز.'
    }
  },
  
  // Nuevas traducciones para tipos de notificaciones
  types: {
    booking_new: 'New Booking',
    booking_update: 'Updated Booking',
    booking_cancel: 'Cancelled Booking',
    booking_request: 'طلب حجز',
    booking_request_approved: 'طلب مقبول',
    booking_request_rejected: 'طلب مرفوض',
    checkin: 'Check-in',
    service: 'Service'
  }
}
